import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/incassozaken')({
    component: IncassozakenPage,
});

function IncassozakenPage() {
    return <h1 className="p-6 text-lg font-medium text-[#202020]">Incassozaken</h1>;
}
